const silenceErrorSymbol = Symbol("silence");

// A silenced error will not show an error toast, but it may still be
// logged to the console with one of these levels.
export type SilencedLogLevel = "none" | "info" | "warn" | "error";

export function silenceError<E>(error: E, logLevel: SilencedLogLevel = "info"): E {
  (
    error as unknown as {
      [silenceErrorSymbol]: SilencedLogLevel;
    }
  )[silenceErrorSymbol] = logLevel;
  return error;
}

export function getSilenceErrorLevel(error: unknown): SilencedLogLevel | null {
  if (typeof error === "object" && error !== null && silenceErrorSymbol in error) {
    return error[silenceErrorSymbol] as SilencedLogLevel;
  }
  return null;
}
